import { useRef, useEffect, useState } from "react";
import axios from "axios";
import { motion, useScroll, useTransform } from "framer-motion";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ImageBand({ src, alt, caption, tag, testid, slot }) {
  const ref = useRef(null);
  const [remote, setRemote] = useState(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  useEffect(() => {
    if (!slot) return;
    axios.get(`${BACKEND}/api/public/site-images?slot=${slot}`)
      .then((r) => setRemote(r.data[0] || null)).catch(() => {});
  }, [slot]);

  const imgSrc = remote ? `${BACKEND}${remote.url}` : src;
  const imgAlt = remote?.alt || alt;
  const cap = remote?.title || caption;

  return (
    <section data-testid={testid} ref={ref} className="relative overflow-hidden border-b border-white/10">
      <div className="relative aspect-[4/3] overflow-hidden sm:aspect-[21/9]">
        <motion.img
          data-testid={`${testid}-image`}
          src={imgSrc}
          alt={imgAlt}
          loading="lazy"
          style={{ scale, y }}
          className="h-full w-full object-cover brightness-[0.85] contrast-110"
        />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_45%,transparent_25%,rgba(9,9,11,0.78)_100%)]" />
        <span className="absolute left-4 top-4 h-5 w-5 border-l-2 border-t-2 border-[#F5B301]" />
        <span className="absolute bottom-4 right-4 h-5 w-5 border-b-2 border-r-2 border-[#F5B301]" />
        <p className="absolute bottom-5 left-5 font-tac text-[10px] tracking-[0.3em] text-white/60">
          {cap}
        </p>
        <p className="absolute right-5 top-5 font-tac text-[10px] tracking-[0.3em] text-white/40">
          {tag}
        </p>
      </div>
    </section>
  );
}
